// В РАЗРАБОТКЕ
import TabButton from "./TabButton";

interface Props {
  tabs: {
    id: string; // id: TabType;
    label: string;
    component: React.ReactNode;
  }[];
  activeTab: string; // activeTab: TabType;
  changeActiveTab: (tab: string) => void; // changeActiveTab: (tab: TabType) => void;
}
 
export default function Sidebar({ tabs, activeTab, changeActiveTab }: Props) {
  return(
    <div className="universaleditmodal-left-sidebar">
      {tabs.map(tab => (
        <TabButton
        key={tab.id}
        sider={tab.id}
        label={tab.label}
        activeTab={activeTab}
        changeActiveTab={changeActiveTab}
        />
      ))}
    </div>
  );
}